<template>
    <div class="ns-orders">
        <el-card>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="3" :lg="3" :xl="3">
                    <div class="header-section">
                        <div>
                            <div style="color: #e29d5a; font-weight: 600;">Orders</div>
                            <div class="text-xs" style="margin-top: 10px;">
                                {{ todaysDate | formatDate }}
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                    <p class="input-label">Store</p>
                    <el-select v-model="selected_store" v-validate="'required'" placeholder="Select Store" filterable
                        class="custom-input store-select-dd capitalize" style="text-transform: capitalize !important; width: 100%"
                        size="medium" @change="handleStoreChange()" @remove="handleStoreRemove">
                        <el-option v-for="(item, store_list_index) in store_list" :key="store_list_index"
                            :value="item.id" :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
                    <p class="input-label">Week</p>
                    <el-date-picker size="medium" v-model="select_week" v-validate="'required'" type="week"
                        :clearable="false" class="custom-input" style="width: 100%" name="Select Week"
                        :format="customDateFormat" arrival placeholder="Pick a week"
                        :picker-options="weekRangeOptionsForMonthly" @change="handleWeekChange()">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                    <p class="input-label">Search</p>
                    <el-input v-model="search_item" clearable placeholder="Search by item name or code" class="custom-input"
                        style="width: 100%" name="Search Item" size="medium">
                    </el-input>              
                </el-col>
                <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
                    <p class="input-label">Filter By Suppliers</p>
                    <el-select v-model="selected_sup" v-validate="'required'" placeholder="Select Suppliers" filterable
                        class="custom-input store-select-dd capitalize" style="text-transform: capitalize !important; width: 100%"
                        size="medium" multiple collapse-tags @change="getOrdersSummaryData()">
                        <el-option v-for="(item, sup_index) in suppliers_list" :key="sup_index"
                            :value="item.supplier_id" :label="item.supplier_name">
                            {{ item.supplier_name }}
                        </el-option>
                    </el-select>         
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
                    <p class="input-label">Filter By Department</p>
                    <el-select v-model="selected_dept" v-validate="'required'" placeholder="Select Department" filterable
                        class="custom-input store-select-dd capitalize" style="text-transform: capitalize !important; width: 100%"
                        size="medium" multiple collapse-tags @change="getOrdersSummaryData()">
                        <el-option v-for="(item, dept_index) in departments_list" :key="dept_index"
                            :value="item.category_id" :label="item.category_name">
                            {{ item.category_name }}
                        </el-option>
                    </el-select>         
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="3" :lg="3" :xl="3">
                    <p class="input-label">&nbsp;</p>
                    <el-button :disabled="table_loading" type="primary" @click="openReportModal" class="ns-button" icon="el-icon-download" style="width: 100%" size="medium">Report Download</el-button>         
                </el-col>
            </el-row>
        </el-card>
        <!-- Order details -->
        <el-card v-loading="table_loading" class="mt-4">
            <div class="table-container">
                <div v-if="!computedOrdersData.length">
                    <el-empty description="Orders data not found!"></el-empty>
                </div>
                <!-- Expanded table -->
                <table v-else-if="is_expanded" class=" ns-table ns-order-table ns-table-expanded">
                    <thead>
                        <tr>
                            <th>Order Date</th>
                            <th colspan="7" style="text-align: center;">
                                <div class="mr-6 text-right text-amplitude cursor-pointer text-center" style="font-size: 12px; text-transform: capitalize;" @click="collapseDate(date)">
                                    <span class="flex items-center my-2 justify-center ml-8">
                                        <svg fill="#e29d5a" class="mr-2" style="width: 15px" version="1.1" id="Layer_1" xmlns:x="&amp;ns_extend;" xmlns:i="&amp;ns_ai;" xmlns:graph="&amp;ns_graphs;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <metadata> <sfw xmlns="&amp;ns_sfw;"> <slices> </slices> <slicesourcebounds width="505" height="984" bottomleftorigin="true" x="0" y="-984"> </slicesourcebounds> </sfw> </metadata> <g> <g> <g> <path d="M8,9H4C3.4,9,3,8.6,3,8s0.4-1,1-1h4c0.6,0,1,0.4,1,1S8.6,9,8,9z"></path> </g> </g> <g> <g> <path d="M8,9C7.4,9,7,8.6,7,8V4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C9,8.6,8.6,9,8,9z"></path> </g> </g> <g> <g> <path d="M8,9C7.7,9,7.5,8.9,7.3,8.7l-7-7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l7,7c0.4,0.4,0.4,1,0,1.4C8.5,8.9,8.3,9,8,9z"></path> </g> </g> <g> <g> <path d="M20,9h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S20.6,9,20,9z"></path> </g> </g> <g> <g> <path d="M16,9c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C17,8.6,16.6,9,16,9z"></path> </g> </g> <g> <g> <path d="M16,9c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7-7c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-7,7C16.5,8.9,16.3,9,16,9z"></path> </g> </g> <g> <g> <path d="M8,17H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S8.6,17,8,17z"></path> </g> </g> <g> <g> <path d="M8,21c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C9,20.6,8.6,21,8,21z"></path> </g> </g> <g> <g> <path d="M1,24c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7-7c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-7,7C1.5,23.9,1.3,24,1,24z"></path> </g> </g> <g> <g> <path d="M20,17h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S20.6,17,20,17z"></path> </g> </g> <g> <g> <path d="M16,21c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C17,20.6,16.6,21,16,21z"></path> </g> </g> <g> <g> <path d="M23,24c-0.3,0-0.5-0.1-0.7-0.3l-7-7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l7,7c0.4,0.4,0.4,1,0,1.4C23.5,23.9,23.3,24,23,24z "></path> </g> </g> </g> </g></svg>
                                        Collapse
                                    </span>
                                </div>
                                {{ moment(expanded_date, "YYYY-MM-DD").format("dddd, MMMM Do") }}
                            </th>
                        </tr>
                        <tr>
                            <th>
                                <div>
                                    Item
                                    <el-popover placement="bottom" trigger="click">
                                        <div class="mb-3 mr-3">
                                            <el-input v-model="search_item_name" clearable placeholder="Search by item name"></el-input>
                                        </div>
                                        <div v-if="item_list.length" class="ns-orders-item-pp">
                                            <el-checkbox-group v-model="selected_item_list">
                                                <el-checkbox
                                                    v-for="(item, item_index) in item_list"
                                                    :key="item_index"
                                                    class="mb-2 checkbox-lable"
                                                    :label="item.name"
                                                    style="display: block"
                                                    @change="addItemFilter(item.name)"
                                                ></el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                        <!-- If data not found -->
                                        <span v-if="!item_list.length">No records found !</span>
                                        <div class="flex justify-between mt-4">
                                            <span
                                                class="text-xs cursor-pointer primary-theme-color"
                                                @click="selectAllItems()"
                                                >Select all</span
                                            >
                                            <span
                                                class="text-xs cursor-pointer"
                                                @click="resetSelectedItems()"
                                                >Reset</span
                                            >
                                        </div>
                                        <span slot="reference">
                                            <img
                                            v-if="!itemActiveFilter"
                                            src="../../assets/images/filterBlack.png"
                                            width="9"
                                            alt=""
                                            />
                                            <img
                                            v-if="itemActiveFilter"
                                            src="../../assets/images/filter.png"
                                            width="9"
                                            alt=""
                                            />
                                        </span>
                                    </el-popover>
                                </div>
                                <div class="mt-2">Total</div>
                            </th>
                            <th>
                                <div>FORECAST</div>
                                <div class="capitalize mt-2 font-normal text-lg"> <span class="font-semibold">{{ orders_summary_data[expanded_date].forecast_qty }}</span></div>
                            </th>
                            <th>
                                <div>CLOSING STOCK</div>
                                <div class="capitalize mt-2 font-normal text-lg"> <span class="font-semibold">{{ orders_summary_data[expanded_date].closing_qty }}</span></div>
                            </th>
                            <th>
                                <div>IDEAL ORDER QTY</div>
                                <div class="capitalize mt-2 font-normal text-lg"> <span class="font-semibold">{{ orders_summary_data[expanded_date].ideal_order_qty }}</span></div>
                            </th>
                            <th> 
                                <div>ORDER QTY</div> 
                                <div class="capitalize mt-2 font-normal text-lg"> <span class="font-semibold">{{ orders_summary_data[expanded_date].order_qty }}</span></div>
                            </th>
                            <th>
                                <div>ARRIVAL DATE</div>
                                <div class="capitalize mt-2 font-normal"> - </div>
                            </th>
                            <th>
                                <div>ORDER UNIT</div>
                                <div class="capitalize mt-2 font-normal"> - </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="article in computedOrdersData" :class="article.article_id == 'total' && 'ns-or-f-row-2'" :key="article.article_id">
                            <td width="405px">
                                <div class="ns-o-article-name font-semibold my-1" style="margin-right: 1px;">{{ article.article_name }}</div>
                                <div v-if="article.article_id !== 'total'" class="ns-o-article-code text-sm">{{ article.article_code }}</div>
                                <div v-if="article.article_id !== 'total'" class="ns-o-article-code text-xs mt-1">{{ article.sup_name }}</div>
                            </td>
                            <td>{{ article[expanded_date].forecast_qty }} <span class="lowercase">{{ article[expanded_date].base_unit }}</span></td>
                            <td>{{ article[expanded_date].closing_qty }}</td>
                            <td>{{ article[expanded_date].ideal_order_qty }}</td>
                            <td>
                                <div v-if="article.article_id == 'total'">
                                    <el-input-number v-model="article[expanded_date].order_qty" :disabled="true" :min="article[expanded_date].min_order_quantity" :max="1000" size="mini" :step="article[expanded_date].rounding_quantity" step-strictly :precision="0"></el-input-number>
                                    <!-- <span class="lowercase"> {{ article[expanded_date].order_unit }}</span> -->
                                </div>
                                <div v-else>
                                    <el-input-number v-if="article[expanded_date].order_id" v-model="article[expanded_date].order_qty" :disabled="!checkIsEditable(expanded_date, article[expanded_date].order_id)" :min="article[expanded_date].min_order_quantity" :max="1000" size="mini" :step="article[expanded_date].rounding_quantity" step-strictly @change="handleChange(article[expanded_date].order_id, article[expanded_date].order_qty, expanded_date, article.article_id, article)" :precision="0"></el-input-number>
                                    <el-input-number v-else v-model="dummy_value" disabled :precision="0" size="mini" ></el-input-number>
                                    <!-- <span class="lowercase"> &nbsp; {{ article[expanded_date].order_unit }}</span> -->
                                </div>
                                <!-- <span v-else>
                                    {{ article[expanded_date].order_qty }}
                                </span> -->
                            </td>
                            <td>{{ article.article_id == 'total' ? '-' : article[expanded_date].arrival_date }}</td>
                            <td style="text-transform: lowercase !important;">
                                <span v-if="article.article_id == 'total'">
                                    -
                                </span>
                                <span v-else>
                                    {{ article[expanded_date].order_unit_conversion }} {{ article[expanded_date].base_unit }} = 1 {{article[expanded_date].order_unit}}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- Collapsed table -->
                <table v-else class=" ns-table ns-order-table">
                    <thead>
                        <tr>
                            <th>Order Date</th>
                            <th v-for="date in weekDates" :key="date">
                                <div class="text-right text-amplitude cursor-pointer" style="font-size: 12px; text-transform: capitalize;" @click="expandDate(date)">
                                    <span class="flex items-center my-2 justify-center">
                                        <svg viewBox="0 0 24 24" fill="none" class="mr-2" style="width: 15px" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4.75 9.233C4.75 9.64721 5.08579 9.983 5.5 9.983C5.91421 9.983 6.25 9.64721 6.25 9.233H4.75ZM6.25 5.5C6.25 5.08579 5.91421 4.75 5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5H6.25ZM5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5C4.75 5.91421 5.08579 6.25 5.5 6.25V4.75ZM9.233 6.25C9.64721 6.25 9.983 5.91421 9.983 5.5C9.983 5.08579 9.64721 4.75 9.233 4.75V6.25ZM6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L6.03033 4.96967ZM9.96967 11.0303C10.2626 11.3232 10.7374 11.3232 11.0303 11.0303C11.3232 10.7374 11.3232 10.2626 11.0303 9.96967L9.96967 11.0303ZM15.767 18.75C15.3528 18.75 15.017 19.0858 15.017 19.5C15.017 19.9142 15.3528 20.25 15.767 20.25V18.75ZM19.5 20.25C19.9142 20.25 20.25 19.9142 20.25 19.5C20.25 19.0858 19.9142 18.75 19.5 18.75V20.25ZM18.75 19.5C18.75 19.9142 19.0858 20.25 19.5 20.25C19.9142 20.25 20.25 19.9142 20.25 19.5H18.75ZM20.25 15.767C20.25 15.3528 19.9142 15.017 19.5 15.017C19.0858 15.017 18.75 15.3528 18.75 15.767H20.25ZM18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L18.9697 20.0303ZM15.0303 13.9697C14.7374 13.6768 14.2626 13.6768 13.9697 13.9697C13.6768 14.2626 13.6768 14.7374 13.9697 15.0303L15.0303 13.9697ZM6.25 15.767C6.25 15.3528 5.91421 15.017 5.5 15.017C5.08579 15.017 4.75 15.3528 4.75 15.767H6.25ZM4.75 19.5C4.75 19.9142 5.08579 20.25 5.5 20.25C5.91421 20.25 6.25 19.9142 6.25 19.5H4.75ZM5.5 18.75C5.08579 18.75 4.75 19.0858 4.75 19.5C4.75 19.9142 5.08579 20.25 5.5 20.25V18.75ZM9.233 20.25C9.64721 20.25 9.983 19.9142 9.983 19.5C9.983 19.0858 9.64721 18.75 9.233 18.75V20.25ZM4.96967 18.9697C4.67678 19.2626 4.67678 19.7374 4.96967 20.0303C5.26256 20.3232 5.73744 20.3232 6.03033 20.0303L4.96967 18.9697ZM11.0303 15.0303C11.3232 14.7374 11.3232 14.2626 11.0303 13.9697C10.7374 13.6768 10.2626 13.6768 9.96967 13.9697L11.0303 15.0303ZM15.767 4.75C15.3528 4.75 15.017 5.08579 15.017 5.5C15.017 5.91421 15.3528 6.25 15.767 6.25V4.75ZM19.5 6.25C19.9142 6.25 20.25 5.91421 20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75V6.25ZM20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75C19.0858 4.75 18.75 5.08579 18.75 5.5H20.25ZM18.75 9.233C18.75 9.64721 19.0858 9.983 19.5 9.983C19.9142 9.983 20.25 9.64721 20.25 9.233H18.75ZM20.0303 6.03033C20.3232 5.73744 20.3232 5.26256 20.0303 4.96967C19.7374 4.67678 19.2626 4.67678 18.9697 4.96967L20.0303 6.03033ZM13.9697 9.96967C13.6768 10.2626 13.6768 10.7374 13.9697 11.0303C14.2626 11.3232 14.7374 11.3232 15.0303 11.0303L13.9697 9.96967ZM6.25 9.233V5.5H4.75V9.233H6.25ZM5.5 6.25H9.233V4.75H5.5V6.25ZM4.96967 6.03033L9.96967 11.0303L11.0303 9.96967L6.03033 4.96967L4.96967 6.03033ZM15.767 20.25H19.5V18.75H15.767V20.25ZM20.25 19.5V15.767H18.75V19.5H20.25ZM20.0303 18.9697L15.0303 13.9697L13.9697 15.0303L18.9697 20.0303L20.0303 18.9697ZM4.75 15.767V19.5H6.25V15.767H4.75ZM5.5 20.25H9.233V18.75H5.5V20.25ZM6.03033 20.0303L11.0303 15.0303L9.96967 13.9697L4.96967 18.9697L6.03033 20.0303ZM15.767 6.25H19.5V4.75H15.767V6.25ZM18.75 5.5V9.233H20.25V5.5H18.75ZM18.9697 4.96967L13.9697 9.96967L15.0303 11.0303L20.0303 6.03033L18.9697 4.96967Z" fill="#e29d5a"></path> </g></svg>
                                        Expand
                                    </span>
                                </div>
                                {{ moment(date, "YYYY-MM-DD").format("dddd, MMMM Do") }}
                                <div class="text-right text-amplitude cursor-pointer" style="font-size: 12px; text-transform: capitalize;" @click="downloadCsv(date)">
                                    <span class="flex items-center mt-2 justify-center">
                                        <i class="el-icon-download mr-1"></i>
                                        Download CSV
                                    </span>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>
                                <div>
                                    Item
                                    <el-popover placement="bottom" trigger="click">
                                        <div class="mb-3 mr-3">
                                            <el-input v-model="search_item_name" clearable placeholder="Search by item name"></el-input>
                                        </div>
                                        <div v-if="item_list.length" class="ns-orders-item-pp">
                                            <el-checkbox-group v-model="selected_item_list">
                                                <el-checkbox
                                                    v-for="(item, item_index) in item_list"
                                                    :key="item_index"
                                                    class="mb-2 checkbox-lable"
                                                    :label="item.name"
                                                    style="display: block"
                                                    @change="addItemFilter(item.name)"
                                                ></el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                        <!-- If data not found -->
                                        <span v-if="!item_list.length">No records found !</span>
                                        <div class="flex justify-between mt-4">
                                            <span
                                                class="text-xs cursor-pointer primary-theme-color"
                                                @click="selectAllItems()"
                                                >Select all</span
                                            >
                                            <span
                                                class="text-xs cursor-pointer"
                                                @click="resetSelectedItems()"
                                                >Reset</span
                                            >
                                        </div>
                                        <span slot="reference">
                                            <img
                                            v-if="!itemActiveFilter"
                                            src="../../assets/images/filterBlack.png"
                                            width="9"
                                            alt=""
                                            />
                                            <img
                                            v-if="itemActiveFilter"
                                            src="../../assets/images/filter.png"
                                            width="9"
                                            alt=""
                                            />
                                        </span>
                                    </el-popover>
                                </div>
                                <div class="mt-2">Total</div>
                            </th>
                            <th v-for="date in weekDates" :key="date+'-item'"> 
                                <div>ORDER QTY</div> 
                                <div class="capitalize mt-2 font-normal text-lg">  <span class="font-semibold">{{ orders_summary_data[date] && orders_summary_data[date] ? orders_summary_data[date].order_qty : '-' }}</span></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="article in computedOrdersData" :class="article.article_id == 'total' && 'ns-or-f-row'" :key="article.article_id">
                            <td width="405px">
                                <div class="ns-o-article-name font-semibold my-1" style="margin-right: 1px;">{{ article.article_name }}</div>
                                <div v-if="article.article_id !== 'total'" class="ns-o-article-code text-sm">{{ article.article_code }}</div>
                                <div v-if="article.article_id !== 'total'" class="ns-o-article-code text-xs mt-1">{{ article.sup_name }}</div>
                            </td>
                            <td v-for="(data, index) in article.article_data" :key="'order-qty-'+ data.order_qty + '-' + index">
                                <div v-if="article.article_id == 'total'">
                                    <el-input-number v-model="data.order_qty" :disabled="!data.is_editable" :precision="0" :min="data.min_order_quantity" :max="1000" size="mini" :step="data.rounding_quantity" step-strictly @change="handleChange(data.order_id, data.order_qty, data.date, article.article_id)" ></el-input-number>
                                </div>
                                <div v-else>
                                    <span v-if="data.order_id == null"> - </span>
                                    <el-input-number v-else v-model="data.order_qty" :disabled="!data.is_editable" :precision="0" :min="data.min_order_quantity" :max="1000" size="mini" :step="data.rounding_quantity" step-strictly @change="handleChange(data.order_id, data.order_qty, data.date, article.article_id)" ></el-input-number>
                                </div>
                                <!-- <span v-else>{{ data.order_qty }}</span> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </el-card>

        <!-- Dialogs -->
        <el-dialog
            title="Download Orders Report"
            :visible.sync="show_report_modal"
            width="30%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="ns-dialog"
        >
            <el-row :gutter="20">
                <el-col :span="24" class="my-3">
                    <p class="text-sm font-semibold mb-2">Select Stores <span class="text-red">*</span></p>
                    <el-select v-model="report_stores" v-validate="'required'" multiple placeholder="Select Stores" collapse-tags="" filterable
                        class="custom-input store-select-dd capitalize" style="text-transform: capitalize !important; width: 100%" name="r_store"
                        size="medium">
                        <div class="flex justify-between sticky top-0 text-amplitude text-xs px-4 my-3 font-semibold cursor-pointer">
                            <span @click="selectAllStores()">Select All</span>
                            <span @click="clearSelectedStores()">Clear</span>
                        </div>
                        <el-option v-for="(item, store_list_index) in storeTypeList" :key="store_list_index"
                            :value="item.id" :label="item.name">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <!-- Show errors -->
                    <span v-show="errors.has('r_store')" class="text-red text-xs">{{ errors.first('r_store') ? 'Required Field' : ''}}</span>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="my-3">
                <el-col :span="12">
                    <p class="text-sm font-semibold mb-2">Start date <span class="text-red">*</span></p>
                    <el-date-picker v-model="report_start_date" v-validate="'required'" type="date" placeholder="Report Start date" style="width: 100%" name="r_start_date" size="medium" @change="handleStartDate"></el-date-picker>
                    <!-- Show errors -->
                    <span v-show="errors.has('r_start_date')" class="text-red text-xs">{{ errors.first('r_start_date') ? 'Required Field' : ''}}</span>
                </el-col>
                <el-col :span="12">
                    <p class="text-sm font-semibold mb-2">End Date <span class="text-red">*</span></p>
                    <el-date-picker v-model="report_end_date" v-validate="'required'" type="date" placeholder="Report End date" style="width: 100%" :picker-options="endDateOpt" name="r_end_date" size="medium"></el-date-picker>
                    <!-- Show errors -->
                    <span v-show="errors.has('r_end_date')" class="text-red text-xs">{{ errors.first('r_end_date') ? 'Required Field' : ''}}</span>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mt-6">
                <el-col :span="24" style="float: right;">
                    <el-button type="primary" class="ns-button" :loading="report_loading" @click="downloadOrdersReport">Download</el-button>
                </el-col>
            </el-row>
            <!-- Note: can select only 30 days -->
            <div class="text-xs text-grey-500 mt-5">Note: Please select less than or equal to 30 days to download orders report.</div>
        </el-dialog>
    </div>
</template>

<script>
import api from "../../services/labourPalnningService";
import orders_api from "../../services/inventoryService";
import moment from 'moment'
import debounce from 'lodash/debounce';
import { mapActions } from "vuex";
export default {
    name: "Orders",
    filters: {
        formatDate: function (value) {
            if (!value) return ''
            const date = new Date(value)
            return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        }
    },
    data() {
        return {
            moment,
            todaysDate: new Date(),
            selected_store: '',
            store_list: [],
            select_week: '',
            customDateFormat: '',
            weekRangeOptionsForMonthly: {
                firstDayOfWeek: 1,
            },
            orders_data: [],
            table_loading: false,
            is_expanded: false,
            expanded_date: '',
            search_item_name: '',
            selected_item_list: [],
            itemActiveFilter: false,
            orders_data_clone: [],
            search_item: '',
            report_stores: [],
            report_start_date: '',
            report_end_date: '',
            show_report_modal: false,
            report_loading: false,
            orders_summary_data: [],
            orders_summary_data_clone: [],
            dummy_value: '-',
            departments_list: [],
            selected_dept: [],
            selected_sup: [],
            suppliers_list: [],
        }
    },
    computed: {
        start_date() {
            return this.getWeekBoundaries(this.select_week).first
        },
        end_date() {
            return this.getWeekBoundaries(this.select_week).last
        },
        item_list() {
            const items = [];
            const originalData = [...this.orders_data_clone];
            originalData.forEach((article) => {
                items.push({
                    name: article.article_name,
                    code: article.article_code
                });
            });
            // Search
            if (this.search_item_name) {
                return items.filter((item) => item.name.toLowerCase().includes(this.search_item_name.toLowerCase()));
            }
            return items;
        },
        weekDates() {
            const firstKey = Object.keys(this.orders_data)[0];
            return firstKey ? Object.keys(this.orders_data[firstKey]) : [];
        },
        computedOrdersData() {
            let dataArray = [];
            const originalData = this.orders_data;
            dataArray = this.formatOrderData(originalData);
            // Filter by item
            if (this.itemActiveFilter) {
                return dataArray.filter((item) => this.selected_item_list.includes(item.article_name));
            }
            // Filter by department
            // if (this.selected_dept.length) {
            //     return dataArray.filter((item) => item.article_id == 'total' || this.selected_dept.includes(item.department_id));
            // }
            if (this.selected_sup.length) {
                dataArray = dataArray.filter((item) => item.article_id == 'total' || this.selected_sup.includes(item.supplier_id));
            }
            // Search
            if (this.search_item) {
                return dataArray.filter((item) => item.article_name.toLowerCase().includes(this.search_item.toLowerCase()) || item.article_code.toLowerCase().includes(this.search_item.toLowerCase()));
            }
            // Unshift total row
            // dataArray.unshift(this.orders_summary_data);
            return dataArray;
        },
        store_id() {
            return this.store_list.find((store) => store.id === this.selected_store).store_id || '';
        },
        endDateOpt() {
            return {
                disabledDate: time => {
                if (!this.report_start_date) {
                    return false; // Enable all dates if no start date selected
                }
                const startDate = new Date(this.report_start_date);
                const endDate = new Date(time);
                const maxDate = new Date(startDate);
                maxDate.setDate(startDate.getDate() + 30); // Allow up to 30 days after start date
                return endDate.getTime() < startDate.getTime() || endDate.getTime() > maxDate.getTime();
                }
            };
        },
        storeTypeList(){
            return this.store_list.filter((store) => store.type === 'store');
        }
    },
    created() {
        this.getStoreList()
    },
    methods: {
        ...mapActions("CommonStore", ["addDownloadingReportCountAction", "removeDownloadingReportCountAction"]),
        getStoreList() {
            api.getAllStoreData().then((res) => {
                this.store_list = JSON.parse(res.data);
                const store = localStorage.getItem('store_id') || localStorage.getItem('store');
                if (!this.selected_store && !store) {
                    this.selected_store = this.store_list[0].id;
                    localStorage.setItem('store_id', this.selected_store);
                    localStorage.setItem('store', this.selected_store);
                } else {
                    this.selected_store = store;
                }
                if (!this.select_week) {
                    this.select_week = new Date();
                    this.customDateFormat = `${this.start_date} To ${this.end_date}`
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                this.getOrdersData()
            });
        },
        selectAllStores(){
            this.report_stores = this.storeTypeList.map((store) => store.id);
        },
        clearSelectedStores(){
            this.report_stores = [];
        },
        openReportModal() {
            this.show_report_modal = true;
            this.report_stores = this.storeTypeList.map((store) => store.id);
            this.report_start_date = this.start_date;
            this.report_end_date = this.end_date;
        },
        downloadOrdersReport(){
            const payload = {
                outlets: this.report_stores,
                start_date: moment(this.report_start_date).format('YYYY-MM-DD'),
                end_date: moment(this.report_end_date).format('YYYY-MM-DD'),
                // suppliers: this.selected_sup
            }
            this.$validator.validateAll(["r_store", "r_start_date", "r_end_date"]).then((result) => {
                console.log('result', result)
                if (result) {
                    this.report_loading = true;
                    this.addDownloadingReportCountAction();
                    orders_api.downloadOrdersReport(payload).then((res) => {
                        this.report_loading = false;
                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `Orders Report ${moment(this.report_start_date).format('YYYY-MM-DD')} ${moment(this.report_end_date).format('YYYY-MM-DD')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        this.show_report_modal = false;
                        this.removeDownloadingReportCountAction();
                    }).catch((err) => {
                        this.report_loading = false;
                        this.removeDownloadingReportCountAction();
                        console.log(err);
                        this.$notify({
                            title: 'Error',
                            message: 'Error in downloading CSV',
                            type: 'error'
                        })
                    });
                } else {
                    this.report_loading = false;
                    // this.removeDownloadingReportCountAction();
                }
            });
        },
        selectAllItems() {
            this.selected_item_list = this.item_list.map((item) => item.name);
            this.itemActiveFilter = true;
        },
        resetSelectedItems() {
            this.selected_item_list = [];
            this.itemActiveFilter = false;
        },
        getDeptName(id){
            const dept = this.departments_list.find((dept) => dept.category_id === id);
            return dept ? dept.category_name : '';
        },
        getSupName(id){
            const dept = this.suppliers_list.find((dept) => dept.supplier_id === id);
            return dept ? dept.supplier_name : '';
        },
        formatOrderData(originalData, isTotal = false) {
            let dataArray = [];
            for (const articleId in originalData) {
                const articleData = originalData[articleId];
                const articleDates = Object.keys(articleData);
                const firstKey = Object.keys(articleData)[0];
                console.log('articleData',articleData, articleData[firstKey])
                const formattedData = {
                    article_id: articleId,
                    article_name: articleData[firstKey] ? articleData[firstKey].name : '',
                    article_code: articleData[firstKey] ? articleData[firstKey].code : '',
                    department_id: articleData[firstKey] ? articleData[firstKey].department_id : '',
                    dept_name: articleData[firstKey] ? this.getDeptName(articleData[firstKey].department_id) : '',
                    supplier_id: articleData[firstKey] ? articleData[firstKey].supplier_id : '',
                    sup_name: articleData[firstKey] ? this.getSupName(articleData[firstKey].supplier_id) : '',
                    ...articleDates.reduce((acc, date) => {
                        acc[date] = {
                            is_editable: this.checkIsEditable(date, articleData[date].order_id),
                            forecast_qty: articleData[date].forecast_qty,
                            total_sales: articleData[date].total_sales,
                            order_qty: articleData[date].order_qty,
                            closing_qty: articleData[date].closing_qty,
                            ideal_order_qty: articleData[date].ideal_order_qty,
                            arrival_date: articleData[date].arrival,
                            order_unit_conversion: articleData[date].order_unit_conversion,
                            order_id: articleData[date].order_id,
                            order_unit: articleData[date].order_unit,
                            base_unit: articleData[date].base_unit,
                            min_order_quantity: articleData[date].min_order_quantity,
                            rounding_quantity: articleData[date].rounding_quantity,
                        };
                        return acc;
                    }, {}),
                    article_data: articleDates.map(date => ({
                        date: date,
                        is_editable: this.checkIsEditable(date, articleData[date].order_id),
                        forecast_qty: articleData[date].forecast_qty,
                        total_sales: articleData[date].total_sales,
                        order_qty: articleData[date].order_qty,
                        closing_qty: articleData[date].closing_qty,
                        ideal_order_qty: articleData[date].ideal_order_qty,
                        arrival_date: articleData[date].arrival,
                        order_unit_conversion: articleData[date].order_unit_conversion,
                        order_id: articleData[date].order_id,
                        order_unit: articleData[date].order_unit,
                        base_unit: articleData[date].base_unit,
                        min_order_quantity: articleData[date].min_order_quantity,
                        rounding_quantity: articleData[date].rounding_quantity,
                    }))
                };
                dataArray.push(formattedData);
            }
            return dataArray;
        },
        addItemFilter(itemName) {
            this.itemActiveFilter = this.selected_item_list.length > 0;
        },
        expandDate(date){
            this.is_expanded = true;
            this.expanded_date = date;
        },
        handleStartDate(){
            // If start date is greater than end date then clear end date
            if(moment(this.report_start_date) > moment(this.report_end_date)){
                this.report_end_date = '';
            }
        },
        downloadCsv(date){
            const payload = {
                outlet: this.selected_store,
                date: date,
                suppliers: this.selected_sup
            }
                this.addDownloadingReportCountAction();
            orders_api.downloadOrdersCsv(payload).then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.store_id}-${date}-orders.csv`);
                document.body.appendChild(link);
                link.click();
                this.removeDownloadingReportCountAction();
            }).catch((err) => {
                this.removeDownloadingReportCountAction();
                console.log(err);
                this.$notify({
                    title: 'Error',
                    message: 'Error in downloading CSV',
                    type: 'error'
                })
            });
        },
        collapseDate(date){
            this.is_expanded = false;
            this.expanded_date = '';
        },
        checkIsEditable(date, id){
            if(id === null) return false;
            if(id === 'total') return false;
            // Only day condition
            // const today_date = moment().format('YYYY-MM-DD');
            // const td_after_2_days = moment().add(2, 'days').format('YYYY-MM-DD');
            // return date === td_after_2_days;
            const todayDate = moment().format('YYYY-MM-DD');
            const todayPlus2Days = moment();
            const endTime = moment().set({ hours: 17, minutes: 30, seconds: 0 }); // 5:30 PM
            const currentTime = moment();

            // Check if the date is today + 2 days and within the time range
            return date === todayPlus2Days.format('YYYY-MM-DD') && 
                todayPlus2Days.isSameOrAfter(currentTime) && 
                currentTime.isSameOrAfter(moment().set({ hours: 6, minutes: 0, seconds: 0 })) && 
                todayDate <= todayPlus2Days.format('YYYY-MM-DD') && 
                currentTime <= endTime;
        },
        handleStoreChange() {
            this.selected_dept = [];
            localStorage.setItem('store_id', this.selected_store);
            localStorage.setItem('store', this.selected_store);
            this.getOrdersData();
        },
        handleStoreRemove() {
            this.selected_store = ''
        },
        handleWeekChange() {
            // const first_day = this.getWeekBoundaries(this.select_week).first
            // const last_day = this.getWeekBoundaries(this.select_week).last
            this.customDateFormat = `${this.start_date} To ${this.end_date}`
            this.getOrdersData();
        },
        getWeekBoundaries(date) {
            // Ensure date is a Moment object
            date = moment(date);
            // Get the first day of the week (Monday) and the last day of the week (Sunday)
            const firstDayOfWeek = date.clone().startOf('isoWeek');
            const lastDayOfWeek = date.clone().endOf('isoWeek');
            // Format the dates as desired
            const firstDayFormatted = firstDayOfWeek.format('YYYY-MM-DD');
            const lastDayFormatted = lastDayOfWeek.format('YYYY-MM-DD');
            // Return an object containing the first and last day of the week
            return {
                first: firstDayFormatted,
                last: lastDayFormatted
            };
        },
        handleChange(aid, qty, date, article_id, article) {
            console.log(this.orders_data_clone.filter((article) => article.article_id == article_id), 'article data', aid, qty, date, article_id, article)
            const originalQty = this.orders_data_clone.filter((article) => article.article_id === article_id)[0].article_data.filter((d) => d.date === date)[0].order_qty;
            let computedChangedData = this.computedOrdersData.filter((article) => article.article_id === article_id)[0].article_data.filter((d) => d.date === date)[0];
            console.log(computedChangedData, 'computedChangedData')
            // Dont allow decimal values
            if(qty % 1 !== 0){
                this.$notify({
                    title: 'Error',
                    message: 'Please enter a valid quantity',
                    type: 'error'
                })
                console.log(originalQty, 'originalQty');
                computedChangedData.order_qty = originalQty;
                return qty = originalQty;
            }
            clearTimeout(this.handleChangeTimeout);
            this.$forceUpdate();
            // Debounce the api call
            this.handleChangeTimeout = setTimeout(() => {
                const payload = {
                    order_id: aid,
                    updated_qty: qty
                };
                // Debounce the api call
                this.callOrdersAPI(payload);
            }, 1000);
        },
        callOrdersAPI(payload){
            orders_api.updateOrderQty(payload).then((res) => {
                console.log('Order quantity updated successfully');
                // this.$notify({
                //     title: 'Success',
                //     message: 'Order quantity updated successfully',
                //     type: 'success'
                // })
                this.getOrdersData();
                // this.getOrdersSummaryData();
            }).catch((err) => {
                console.log(err);
                this.$notify({
                    title: 'Error',
                    message: 'Error in updating order quantity',
                    type: 'error'
                })
            });
        },
        getDeptList(payload){
            orders_api.getOrderDeptData({outlet: this.selected_store}).then((res) => {
                this.departments_list = JSON.parse(res.data);
            }).catch((err) => {
                console.log(err);
            });
        },
        getSupList(payload){
            orders_api.getSuppliersData({outlet: this.selected_store}).then((res) => {
                this.suppliers_list = JSON.parse(res.data);
            }).catch((err) => {
                console.log(err);
            });
        },
        // handleChange: debounce(function(aid, qty) {
        //     this.$forceUpdate();
        //     const payload = {
        //         order_id: aid,
        //         updated_qty: qty
        //     };
        //     // Debounce the api call
        //     orders_api.updateOrderQty(payload).then((res) => {
        //         this.$notify({
        //         title: 'Success',
        //         message: 'Order quantity updated successfully',
        //         type: 'success'
        //         });
        //     }).catch((err) => {
        //         console.log(err);
        //         this.$notify({
        //         title: 'Error',
        //         message: 'Error in updating order quantity',
        //         type: 'error'
        //         });
        //     });
        //     }, 500),
        getDataByDate(key, aid) {
            let result = '-';
            this.computedOrdersData.find((e)=> e.article_id === aid).article_data.find((d) => {
                if(d.date === this.expanded_date){
                    result = d[key]
                }
            });
            return result;
        },
        getOrdersData() {
            const payload = {
                // outlet: '57727efb-48cc-4de9-8c12-079a85317b67',
                outlet: this.selected_store,
                start_date: this.start_date,
                end_date: this.end_date
            }
            this.getOrdersSummaryData();
            this.getSupList();
            this.table_loading = true;
            orders_api.getOrdersDetails(payload).then((res) => {
                try {
                    this.orders_data = JSON.parse(res.data)
                } catch (error) {
                    this.orders_data = []
                }
                this.table_loading = false;
                const originalData = this.orders_data;
                this.orders_data_clone = this.formatOrderData(originalData);
            }).catch((err) => {
                console.log(err);
                this.table_loading = false;
                this.$notify({
                    title: 'Error',
                    message: 'Error in fetching orders data',
                    type: 'error'
                })
            })
        },
        getOrdersSummaryData() {
            const payload = {
                // outlet: '57727efb-48cc-4de9-8c12-079a85317b67',
                outlet: this.selected_store,
                start_date: this.start_date,
                end_date: this.end_date,
                suppliers: this.selected_sup
            }
            this.table_loading = true;
            orders_api.getOrdersDetailsSummary(payload).then((res) => {
                try {
                    this.orders_summary_data = JSON.parse(res.data)
                } catch (error) {
                    this.orders_summary_data = []
                }
                this.table_loading = false;
                // Initialize or merge the orders_summary_data object correctly
                this.orders_summary_data = {
                    article_code: '-',
                    article_id: 'total',
                    article_name: 'Total',
                    ...this.orders_summary_data
                };

                let originalData = this.orders_summary_data;

                // Add article_data array
               console.log( this.formatOrderSummaryData(originalData), ' this.formatOrderSummaryData(originalData, true);')
            }).catch((err) => {
                console.log(err);
                this.table_loading = false;
                this.$notify({
                    title: 'Error',
                    message: 'Error in fetching orders data',
                    type: 'error'
                })
            })
        },
        formatOrderSummaryData(data){
            const articleDates = Object.keys(data);
            data.article_data = articleDates.map(date => ({
                date: date,
                forecast_qty: data[date].forecast_qty,
                total_sales: data[date].total_sales,
                order_qty: data[date].order_qty,
                closing_qty: data[date].closing_qty,
                ideal_order_qty: data[date].ideal_order_qty,
                arrival_date: '-',
                order_unit_conversion: data[date].order_unit_conversion,
                order_id: data[date].order_id,
                order_unit: data[date].order_unit,
                base_unit: data[date].base_unit,
                min_order_quantity: data[date].min_order_quantity,
                rounding_quantity: data[date].rounding_quantity,
            }));
            // Remove first three elements
            data.article_data.splice(0, 3);
            return data;
        }
    }
}
</script>
<style>
.ns-orders .el-input .el-input__inner{
    text-transform: capitalize !important;
}
.ns-orders .el-form-item{
    margin-bottom: 2px !important;
}
.ns-orders .el-input.is-disabled .el-input__inner {
    background-color: #fdfeff !important;
    border-color: #e4e7ed;
    color: #171717 !important;
    cursor: not-allowed;
}
.ns-button.el-button{
    background: #e29d5a;
    border-color: #e29d5a;
}
.ns-button.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: #e29d5a !important;
    border-color: #e29d5a !important;
}
</style>
<style lang="scss" scoped>
.table-container{
    height: 670px;
    overflow-y: auto;
}
.ns-table th{
    font-size: 14px;
    text-transform: uppercase;
    background: #f8f8f8 !important;
    // padding: 20px 15px;
}
.ns-order-table{
    tbody td{
        font-size: 15px;
        font-weight: 600;
    }
    tbody td:not(:first-child), thead th:not(:first-child){
        text-align: center;
    }
    .ns-o-article-code{
        font-weight: normal !important;
    }
}
.ns-order-table.ns-table-expanded{
    tbody td:not(:first-child), thead th:not(:first-child){
        text-align: center;
    }
}
.ns-orders-item-pp{
    height: 350px;
    overflow-y: auto;
}
.ns-order-table thead{
  position: sticky;
  top: 0;
  z-index: 5;
}
.ns-or-f-row{
  position: sticky;
  top: 160px;
  background: #f8f8f8;
  z-index: 5;
}
.ns-or-f-row-2{
  position: sticky;
  top: 140px;
  background: #f8f8f8;
  z-index: 5;
}
</style>